import { FC } from 'react';

import { InvoiceSendingMethod, InvoiceType } from '__generated__/GQL';
import getErrorMessageIfPossible from 'common/hooks/useErrorHandledMutation/getErrorMessageIfPossible';
import useToast from 'components/ToastProvider/useToast';

import FiscalIdModal from '../../../../../../components/FiscalIdModal';
import useLastQuoteFiscalId from '../../../../../../hooks/useLastQuoteFiscalId';
import useMarkQuoteAsSent from '../../../mutations/useMarkQuoteAsSent';
import { useQuoteModals } from '../..';
import locales from './locales';

export interface MarkAsSentModalProps {
  quoteId: string;
}

const MarkAsSentModal: FC<MarkAsSentModalProps> = ({ quoteId }) => {
  const { hideModal } = useQuoteModals();
  const { showToast } = useToast();

  const { lastQuoteFiscalId, loading } = useLastQuoteFiscalId();
  const { onMarkQuoteAsSent } = useMarkQuoteAsSent();

  const onSubmit = async (fiscalId: string) => {
    try {
      const { data } = await onMarkQuoteAsSent({
        input: { fiscalId, method: InvoiceSendingMethod.None, quoteId },
      });

      showToast({
        message: locales.formatString(
          locales.successMessage,
          data?.markQuoteAsSent?.quote.fiscalId ?? '',
        ) as string,
        type: 'success',
      });
      hideModal();
    } catch (error) {
      showToast({
        message: getErrorMessageIfPossible({ error }) || locales.errorMessage,
        type: 'error',
      });
    }
  };

  return (
    <FiscalIdModal onClose={hideModal}>
      <FiscalIdModal.Body>
        <FiscalIdModal.Body.Title>{locales.title}</FiscalIdModal.Body.Title>

        <FiscalIdModal.Body.Description>
          {locales.description}
        </FiscalIdModal.Body.Description>

        <FiscalIdModal.Body.Input
          fiscalId={lastQuoteFiscalId?.next ?? ''}
          lastFiscalId={lastQuoteFiscalId?.last ?? undefined}
          loading={loading}
          type={InvoiceType.Quote}
        />
      </FiscalIdModal.Body>

      <FiscalIdModal.Footer>
        <FiscalIdModal.Footer.CancelButton onClick={hideModal}>
          {locales.cancel}
        </FiscalIdModal.Footer.CancelButton>

        <FiscalIdModal.Footer.SubmitButton onClick={onSubmit}>
          {locales.submit}
        </FiscalIdModal.Footer.SubmitButton>
      </FiscalIdModal.Footer>
    </FiscalIdModal>
  );
};

export default MarkAsSentModal;
